"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformOrganizationCreditMetricsApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Analytics for organizations.
 */
class SdPlatformOrganizationCreditMetricsApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "organization_credit_metrics";
    }
    /**
     * Query metrics analytics aggregated per organization.
     * @param body the query parameters.
     * @returns collection of {@link SdPlatformResponseCreditMetricOrganization} based on query parameters.
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.OrganizationCreditMetricsQuery, body);
    }
}
exports.SdPlatformOrganizationCreditMetricsApi = SdPlatformOrganizationCreditMetricsApi;
//# sourceMappingURL=SdPlatformOrganizationCreditMetricsApi.js.map